// extracted by mini-css-extract-plugin
module.exports = {"mainPage":"DashboardModelList__mainPage__dUWKI","tabsBox":"DashboardModelList__tabsBox__QUGUY","tabPaneBox":"DashboardModelList__tabPaneBox__0KasW"};